<ng-container *ngIf="kkm$ | async as kkm">
  <tax-page-header [titleText]="kkm.internalName" [dropdownItems]="dropdownItems"></tax-page-header>

  <div class="ui-kit-content-container--with-separators">
    <tax-input
      data-qa-input="kkm-name"
      [labelText]="'transaction.ticket.item.name'"
      [id]="'title'"
      [(ngModel)]="newKkmTitle"
      [autofocus]="true"
      (keydown.enter)="saveNewKkmData(kkm.id)"
      [layoutColumns]="2"
      [clearable]="true"
    ></tax-input>

    <tax-kkm-info [kkm]="kkm"></tax-kkm-info>

    <tax-kkm-reg-status-block
      *ngIf="isRegStatusBlockVisible"
      [kkm]="kkm"
    ></tax-kkm-reg-status-block>

    <div class="token">
      <button class="button_blue" data-qa-button="get-token" (click)="openToken(kkm.id)">
        {{ 'kkm.settings.get.token' | translate }}
      </button>
    </div>

    <tax-kkm-network-info
      *ngIf="kkm.network"
      [(simKkmId)]="newSimKkmId"
      [kkm]="kkm"
    ></tax-kkm-network-info>

    <tax-kkm-tariff-management
      *ngIf="isAnyTariffManagementButtonVisible"
      [kkm]="kkm"
    ></tax-kkm-tariff-management>

    <tax-kkm-retail-place-info></tax-kkm-retail-place-info>

    <tax-kkm-settings-buttons-control
      [isDisable]="!(this.newKkmTitle !== kkm.internalName || newSimKkmId !== kkm.network?.id)"
      (changeKkmData)="saveNewKkmData(kkm.id)"
    ></tax-kkm-settings-buttons-control>
  </div>
</ng-container>
